export const RECEIVE_INFO = 'RECEIVE_INFO';
export const RECEIVE_ADDRESS = 'RECEIVE_ADDRESS';
export const RECEIVE_PHOTOS = 'RECEIVE_PHOTOS';
export const RECEIVE_PROMO_CODE = 'RECEIVE_PROMO_CODE';
